import type { ReactNode } from "react"

import { useTranslation } from "react-i18next"

import { RefreshCw } from "@/components/icons"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

/** Full-height reader for a single plan tile/section (Canvas ⤢ Expand). */
export function ExpandModal({
  open,
  onOpenChange,
  title,
  children,
  canUpdate = false,
  onUpdate,
  updateTestId,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  children: ReactNode
  /** AI fields expose Update here too (handover §8); §06 leaves this false. */
  canUpdate?: boolean
  onUpdate?: () => void
  updateTestId?: string
}) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody className="max-h-[70vh] overflow-y-auto">{children}</DialogBody>
        {canUpdate && onUpdate ? (
          <DialogFooter>
            <Button
              data-testid={updateTestId}
              size="sm"
              variant="outline"
              onClick={() => {
                onUpdate()
                onOpenChange(false)
              }}
            >
              <RefreshCw className="size-3.5" />
              {t("segmentAnalysis.plan.update")}
            </Button>
          </DialogFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}
